import createStore from "astrid-helpers/src/createStore";

import { onProfile } from "./user";

export const [getProducers, setProducers, useProducers, onProducers] = createStore([]);

onProfile((profile) => {
	setProducers(Object.keys(profile?.permissions?.producer || {}));
});
